import { Card } from "@/components/ui/card";

const steps = [
  { n: 1, t: "Apply online", d: "Borrowers, dealers or DSAs create an application with borrower, employment and vehicle details." },
  { n: 2, t: "Upload CarDr report", d: "Upload the CarDr diagnostic PDF. Our underwriter team confirms key fields like DTC counts, repair estimate and grade." },
  { n: 3, t: "Automated valuation", d: "We compute lendable value adjusted for repair exposure, age, mileage and diagnostic discount." },
  { n: 4, t: "Credit rules engine", d: "FOIR, LTV, CIBIL and Red Fort Capital credit policy are evaluated. A draft offer is generated." },
  { n: 5, t: "Underwriter review", d: "Our credit team reviews exceptions, applies counteroffers, and approves the loan." },
  { n: 6, t: "Sanction letter & EMI", d: "Digital sanction letter is generated and an EMI schedule is computed on reducing balance." },
  { n: 7, t: "Disbursement", d: "Loan is disbursed to dealer / seller account. Borrower starts repaying as per schedule." },
];

export default function HowItWorks() {
  return (
    <div className="max-w-5xl mx-auto px-4 lg:px-8 py-16" data-testid="how-it-works-page">
      <div className="text-xs uppercase tracking-wider text-teal-700 font-semibold mb-3">How it works</div>
      <h1 className="text-4xl lg:text-5xl font-semibold text-slate-900">Seven steps from lead to disbursement.</h1>
      <p className="mt-5 text-slate-600 max-w-3xl leading-relaxed">Every CarFin loan moves through a transparent workflow shared between borrowers, dealers, DSAs, and Red Fort Capital's credit team.</p>

      <div className="mt-12 space-y-4">
        {steps.map(s => (
          <Card key={s.n} className="p-5 border-slate-200 flex gap-5 items-start">
            <div className="w-12 h-12 rounded-lg bg-slate-900 text-white grid place-items-center font-semibold flex-shrink-0">{s.n}</div>
            <div>
              <div className="font-semibold text-slate-900 text-lg">{s.t}</div>
              <div className="text-sm text-slate-600 mt-1 leading-relaxed">{s.d}</div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
